import { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  .list-Links {
    color: #57769c;
    display: flex;
    margin: 1rem 0;
    &__item {
      margin-right: 1rem;

      a {
        color: #57769c;
      }
    }
  }
  @media (min-width: 1024px) {
    .list-Links {
      &__item {
        a {
          color: #fff;
        }
      }
    }
  }
`;

const Links = () => {
  const [state] = useState({
    links: [
      { name: "Home", where: "/", target: "_self" },
      {
        name: "Contact",
        where: `${process.env.REACT_APP_PHONE_NUMBER_URL}`,
        target: "_blank",
      },
      {
        name: "Visit Website",
        where: `https://en.multi-edu.com`,
        target: "_blank",
      },
    ],
  });


  return (
    <Container>
      <ul className="list-Links title-400-16-white">
        {state.links.map((link, index) => (
          <li className="list-Links__item" key={index}>
            <a className="title-900-18-white" href={link.where} target={link.target}>
              {link.name}
            </a>
          </li>
        ))}
      </ul>
    </Container>
  );
};

export default Links;
